import { format, isValid } from 'date-fns';
import { getDateWithoutTime } from './getDateWithoutTime';

export const formatDate = (date: string | Date, pattern = 'd MMM yyyy'): string => {
  const dateObj = typeof date === 'string' ? getDateWithoutTime(date) : date;

  if (isValid(dateObj)) {
    return format(dateObj, pattern);
  }

  return 'N/A';
};
